module.exports = __webpack_public_path__ + "img/news-newest@2x.4587a830.png";